import { render, staticRenderFns } from "./AutoConfig.vue?vue&type=template&id=5309f40f&scoped=true&"
import script from "./AutoConfig.vue?vue&type=script&lang=js&"
export * from "./AutoConfig.vue?vue&type=script&lang=js&"
import style0 from "./AutoConfig.vue?vue&type=style&index=0&id=5309f40f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309f40f",
  null
  
)

export default component.exports